export class Drawer {
    constructor(trigger, status) {
        this.trigger = trigger;
        this.status = status;
        this.id = this.trigger.dataset.drawer;
        this.container = document.querySelector(`[data-drawer-container="${this.id}"]`) || '';
        this.inner = document.querySelector(`[data-drawer-inner="${this.id}"]`) || '';
        this.registerEvent();
    }

    registerEvent() {
        if (!this.inner || !this.container) return;
        this.trigger.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
        if (!Object.hasOwn(this.status, this.id)) {
            const h = this.inner.getBoundingClientRect().height;
            this.container.style.height = `${h}px`;
            this.trigger.setAttribute('aria-expanded', true);
            this.status[this.id] = 'active';
        } else {
            this.container.style.height = 0;
            this.trigger.setAttribute('aria-expanded', false);
            delete this.status[this.id];
        }
    }
}
